import { render } from "./RatingBar.vue?vue&type=template&id=e3ae0b9a&scoped=true"
import script from "./RatingBar.vue?vue&type=script&lang=js"
export * from "./RatingBar.vue?vue&type=script&lang=js"

import "./RatingBar.vue?vue&type=style&index=0&id=e3ae0b9a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3ae0b9a"]])

export default __exports__